import { render, staticRenderFns } from "./profileActionItem.vue?vue&type=template&id=c5a80400&scoped=true"
import script from "./profileActionItem.vue?vue&type=script&lang=js"
export * from "./profileActionItem.vue?vue&type=script&lang=js"
import style0 from "./profileActionItem.vue?vue&type=style&index=0&id=c5a80400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a80400",
  null
  
)

export default component.exports